// extracted by mini-css-extract-plugin
module.exports = {"modal":"modifyPasswordModal_modal__Jrm_C"};